import { render } from "./ModeleEconomique.vue?vue&type=template&id=1255ad78"
import script from "./ModeleEconomique.vue?vue&type=script&lang=js"
export * from "./ModeleEconomique.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__